export default __webpack_public_path__ + "a7192364dfc59c43932f28fde84faa41.png";